import React from 'react';
import AppStateStore from '#/stores/AppStateStore';
import { RootStoreContext } from '../stores/RootStoreContext';

export const useAppStateStore = (): AppStateStore => {
    const store = React.useContext(RootStoreContext);
    if (!store) {
        throw new Error('useAppStateStore must be used within a RootStoreProvider.');
    }
    return store.appStateStore;
};
